import type { $TSFixMe } from '@readme/iso';
import type { Element } from 'slate';

import { ImageAlignValues } from '@ui/MarkdownEditor/enums';
import type { FigureElement, FigureMdNode, Serializer } from '@ui/MarkdownEditor/types';

import { serialize as figcaptionSerialize } from '../Figcaption/serialize';
import { serialize as imageSerialize } from '../Image/serialize';

import { type } from './shared';

export const deserialize = (node: FigureMdNode, deeper: (node: FigureMdNode) => Element[]): FigureElement => {
  const children = deeper(node) as FigureElement['children'];
  children[0].align = ImageAlignValues.center;

  return {
    type,
    children,
  };
};

export const serialize: Serializer<FigureElement, FigureMdNode> = (node, deeper): FigureMdNode => {
  const [image, figcaption] = node.children;
  const imageMdNode = imageSerialize(image as $TSFixMe) as $TSFixMe;
  const children: FigureMdNode['children'] = figcaption
    ? // @ts-expect-error -- @todo: these types are a mess
      [imageMdNode, figcaptionSerialize(figcaption, deeper)]
    : [imageMdNode];

  return {
    type,
    data: {
      hName: type,
    },
    children,
  };
};
